import { render } from "./details.vue?vue&type=template&id=0f9bf0b4&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"

import "./details.vue?vue&type=style&index=0&id=0f9bf0b4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/santo_cartao_adm_master/santo_cartao_adm_master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9bf0b4"]])

export default __exports__